import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { hideConfirmModal } from 'actions/global';
import { getErrorMessage } from 'utils';
import BWModal from 'components/shared/BWModal';

const ConfirmModal = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const { confirmMessage, confirmCallback, refuseCallback, labelAccept, labelRefuse } = useSelector(
    (state) => state.global,
  );
  const [isConfirming, setIsConfirming] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const pendingRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    pendingRef.current = null;
    setIsConfirming(false);
    setErrorMessage('');
  }, [confirmMessage]);

  useEffect(() => {
    if (errorMessage) {
      contentRef.current?.closest('[role="dialog"]')?.querySelector('.bw_modal_ds_actions button')?.focus();
    }
  }, [errorMessage]);

  const close = () => {
    if (!pendingRef.current) dispatch(hideConfirmModal());
  };

  const runAction = async (callback) => {
    if (pendingRef.current) return;
    const operation = {};
    pendingRef.current = operation;
    setIsConfirming(true);
    setErrorMessage('');

    try {
      await callback?.();
      if (store.getState().global.confirmMessage === confirmMessage) dispatch(hideConfirmModal());
    } catch (error) {
      if (store.getState().global.confirmMessage === confirmMessage) {
        setErrorMessage(getErrorMessage(error) || 'Không thể hoàn tất thao tác. Vui lòng kiểm tra lại.');
      }
    } finally {
      if (pendingRef.current === operation) {
        pendingRef.current = null;
        setIsConfirming(false);
      }
    }
  };

  const isOpen = Array.isArray(confirmMessage) && confirmMessage.length > 0;

  return (
    <BWModal
      open={isOpen}
      title={errorMessage ? 'Không thể hoàn tất thao tác' : 'Thông báo'}
      size='sm'
      maskClosable={false}
      closeDisabled={isConfirming}
      onClose={close}
      error={errorMessage ? { title: 'Chi tiết lỗi', description: errorMessage } : null}
      primaryAction={errorMessage ? {
        label: 'Quay lại kiểm tra',
        onClick: close,
      } : {
        label: isConfirming ? 'Đang xử lý...' : labelAccept ?? 'Tôi muốn xóa',
        type: 'danger',
        loading: isConfirming,
        onClick: () => runAction(confirmCallback),
      }}
      cancelAction={!errorMessage && labelRefuse !== false ? {
        label: labelRefuse ?? 'Quay về',
        disabled: isConfirming,
        onClick: refuseCallback ? () => runAction(refuseCallback) : close,
      } : null}>
      <div ref={contentRef}>
        {isOpen && confirmMessage.map((message, index) => <div key={index}>{message}</div>)}
      </div>
    </BWModal>
  );
};

export default ConfirmModal;
